import { render } from "./AddressComponent.vue?vue&type=template&id=1a743ecb"
import script from "./AddressComponent.vue?vue&type=script&lang=js"
export * from "./AddressComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/checkout/checkout/AddressComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a743ecb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a743ecb', __exports__)) {
    api.reload('1a743ecb', __exports__)
  }
  
  module.hot.accept("./AddressComponent.vue?vue&type=template&id=1a743ecb", () => {
    api.rerender('1a743ecb', render)
  })

}


export default __exports__